import { ITotalReviews } from 'api/resort/types';
import classNames from 'classnames';
import { useOTSTranslation } from 'i18n/useOTSTranslation';
import styles from './styles.module.scss';

export const LevelReview = ({ count, sum }: { count: number, sum: number }) => {
  const percent = (count * 100) / sum;

  return (
    <div className={styles.rectangles}>
      <div className={styles.rectangleGrey}>
        <div className={styles.rectangleBlue} style={{ width: `${percent}%` }} />
      </div>
    </div>
  );
};

export const TotalReviews = ({
  totalReviews, className,
}: {
  totalReviews: ITotalReviews,
  className?: string,
}) => {
  const { t } = useOTSTranslation('common');
  const sumReviews = Object.values(totalReviews).reduce((prev, item) => prev + item, 0);

  return (
    <>
      {
        sumReviews > 50 ? (
          <div className={classNames(styles.totalReviews, className)}>
            <span className={classNames('h3', styles.h3, styles.title)}>{t('resort.reviews.totalReviews', { count: sumReviews })}</span>
            <div className={styles.starReviews}>
              <div className={styles.row}>
                <div className={styles.subtitle}>
                  {t('resort.reviews.starReviews5', { count: totalReviews['5'] })}
                </div>
                <LevelReview count={totalReviews['5']} sum={sumReviews} />
              </div>
              <div className={styles.row}>
                <div className={styles.subtitle}>
                  {t('resort.reviews.starReviews4', { count: totalReviews['4'] })}
                </div>
                <LevelReview count={totalReviews['4']} sum={sumReviews} />
              </div>
              <div className={styles.row}>
                <div className={styles.subtitle}>
                  {t('resort.reviews.starReviews3', { count: totalReviews['3'] })}
                </div>
                <LevelReview count={totalReviews['3']} sum={sumReviews} />
              </div>
              <div className={styles.row}>
                <div className={styles.subtitle}>
                  {t('resort.reviews.starReviews2', { count: totalReviews['2'] })}
                </div>
                <LevelReview count={totalReviews['2']} sum={sumReviews} />
              </div>
              <div className={styles.row}>
                <div className={styles.subtitle}>
                  {t('resort.reviews.starReviews1', { count: totalReviews['1'] })}
                </div>
                <LevelReview count={totalReviews['1']} sum={sumReviews} />
              </div>
            </div>
          </div>
        ) : ''
      }
    </>
  );
};
